<template>
    <div class="features">
		<div class="features__body">
			<div class="features__title	">
				<div class="features__title_cn">工艺特点 / </div>
				<div class="features__title_en">Process characteristics</div>
				<img src='https://static.zc0901.com/dci-web-product-knowledge.png' class="features__title_bottom" />
			</div>
			<img class="features__line clearFix" src='https://static.zc0901.com/dci-web-features-line-bg.png' />
			<div class="features__content">
				<div>DCI瓷质砖采用纯粹的原料制造，并通过先进的科技进行原料开采和控制。在生产过程中，先对原料进行潮湿研磨，再通过雾化离心蒸发器进行部分干燥，然后经过超10000吨压力（ 450kg/ cm²）的液压冲压，再进行1230摄氏度以上高温处理之后，可以得到密度大、硬度高的瓷质。</div>
				<div>产品吸水率低于0.1%（国际标准为0.5%），机械强度超过50N/mm²（国际标准为35 N/mm²），产品表面不易渗入污渍，更便于清洁打理；瓷质砖抗磨损性低于140mm3，产品表面经久耐磨；其抗冻性高，产品适合于室内、室外场景铺贴；也符合欧盟对于耐酸和耐碱性的标准要求，并一举获得欧盟CE标识认证、AEO认证、ISO 45001、ISO 9001、ISO 14001、中国CCC认证等各项环保安全、经营和质量体系认证，同时成为世界上第一家获得ISO 50001（能源管理体系）认证的陶瓷生产商，以证明DCI生产工厂在产品品质控制、生产工艺环保、环境资源保护等方面做出的突出表现。</div>
			</div>
			<img class="features__bottom" src='../../static/dci-web-features-bg-bottom.png' />
			<img class="features__top" src='../../static/dci-web-features-bg-top.png' />
		</div>
	</div>
</template>
<script>
import "./index.scss";

	export default {
		data() {
			return {
				
			}
		},
		computed: {
			
		},
        created(){
            
        },
		mounted() {
		},
		methods: {}
	}
</script>
<style scoped lang="scss">
  
</style>
<style lang="scss">

</style>
